import { api } from "./client";
import { SoundKey } from "../audio/manifest";

export type SoundManifestEntry = {
  key: SoundKey;
  src: string; // absolute media URL
  volume: number; // 0..1
};

/** Fetch the administrable sound manifest (enabled, file-backed sounds only). */
export async function getSounds(): Promise<SoundManifestEntry[]> {
  const { data } = await api.get<SoundManifestEntry[]>("/api/sounds/");
  return data;
}
